import ServiceCategoryPage from "../components/ServiceCategoryPage";
import rooftopWaterproofingWorkerService from "../data/services/rooftopWaterproofingWorkerService";

function RooftopWaterproofingWorker() {
  return <ServiceCategoryPage service={rooftopWaterproofingWorkerService} />;
}

export default RooftopWaterproofingWorker;